import { Grid } from '@mantine/core'
import { translate } from 'i18n/i18n'
import moment from 'moment-timezone'
import React from 'react'
import { useTimezoneForSelectedPropertyOrRegion } from '../../../../Map/PanelDetails/_utils/useTimezoneForSelectedPropertyOrRegion'
import { ToggleSymbolValue } from '../../../ToggleSymbolValue/ToggleSymbolValue'

type EquipmentLastServiceDates = {
  batteryServicedLastOn?: string | null
  coroplastServicedLastOn?: string | null
  issueServicedLastOn?: string | null
  lureServicedLastOn?: string | null
  linerServicedLastOn?: string | null
}

// Only consider those consumables to determine the last overall service date
const INCLUDE_CONSUMABLES = ['coroplastServicedLastOn', 'lureServicedLastOn', 'linerServicedLastOn']

export const TrapLastService: React.FC<{ lastServiceDates?: EquipmentLastServiceDates }> = ({
  lastServiceDates,
}) => {
  const timezone = useTimezoneForSelectedPropertyOrRegion()

  if (!lastServiceDates) return null

  // Get the latest service date among all consumables
  const lastOverallServiceDate = Object.keys(lastServiceDates)
    .filter((key): key is keyof EquipmentLastServiceDates => INCLUDE_CONSUMABLES.includes(key))
    .reduce(
      (latest, key) => {
        const date = lastServiceDates[key]!

        return !latest || (date && new Date(date) > new Date(latest)) ? date : latest
      },
      null as string | null,
    )

  return (
    <>
      <Grid.Col span={4}>{translate.phrases.placeholder('Last Service')}</Grid.Col>
      <Grid.Col span={8}>
        {lastOverallServiceDate ? (
          <ToggleSymbolValue value={moment.tz(lastOverallServiceDate, timezone).format('lll z')}>
            {lastOverallServiceDate ? moment.tz(lastOverallServiceDate, 'UTC').fromNow() : '-'}
          </ToggleSymbolValue>
        ) : (
          translate.phrases.placeholder('-')
        )}
      </Grid.Col>
    </>
  )
}
